// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` 
.vendor-details-page {
    padding: 20px;
    animation: fadeIn 0.5s ease-in-out;
  }
  
  .details-header {
    margin-bottom: 30px;
  }
  
  .back-link-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #6B7280;
  }
  .back-link-button img {
    width: 24px;
  }
  
  .profile-header {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 40px;
    background-color: #fff;
    padding: 24px;
    border-radius: 12px;
  }
  
  .profile-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #f3f4f6;
  }
  
  .profile-info h1 {
    font-size: 28px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
  }
  
  .profile-actions {
    margin-left: auto;
    display: flex;
    gap: 12px;
  }
  
  .action-btn-secondary, .action-btn-danger {
    border: 1px solid;
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  .action-btn-secondary {
    border-color: #d1d5db;
    background-color: #fff;
    color: #374151;
  }
  .action-btn-secondary:hover {
    background-color: #f9fafb;
  }
  .action-btn-danger {
    border-color: #ef4444;
    background-color: #ef4444;
    color: #fff;
  }
  .action-btn-danger:hover {
    background-color: #dc2626;
  }
  
  
  .details-content {
    background-color: #fff;
    padding: 24px;
    border-radius: 12px;
  }
  .details-content h3 {
    margin-top: 0;
    font-size: 18px;
    border-bottom: 1px solid #f3f4f6;
    padding-bottom: 16px;
    margin-bottom: 24px;
  }
  
  .info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  
  .info-pair {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .info-pair label {
    font-size: 14px;
    color: #6B7280;
  }
  .info-pair span {
    font-size: 16px;
    color: #1F2937;
    font-weight: 500;
    word-break: break-word;
  }
  .info-pair.full-width {
    grid-column: 1 / -1;
  }
  
  /* Status Badges - reuse from previous CSS */
  .status-badge { padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 500; }
  .status-active { background-color: #DEF7EC; color: #046C4E; }
  .status-inactive { background-color: #FEE2E2; color: #991B1B; }
  
  @media (max-width: 768px) {
    .profile-header { flex-direction: column; align-items: flex-start; }
    .profile-actions { margin-left: 0; width: 100%; justify-content: flex-start; }
    .info-grid { grid-template-columns: 1fr; }
  }`, "",{"version":3,"sources":["webpack://./src/pages/VendorDetailsPage/VendorDetailsPage.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;;EAEA,4CAA4C;EAC5C,gBAAgB,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;EAC3F,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;EAC5D,mBAAmB,yBAAyB,EAAE,cAAc,EAAE;;EAE9D;IACE,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE;IACnE,mBAAmB,cAAc,EAAE,WAAW,EAAE,2BAA2B,EAAE;IAC7E,aAAa,0BAA0B,EAAE;EAC3C","sourcesContent":[" \n.vendor-details-page {\n    padding: 20px;\n    animation: fadeIn 0.5s ease-in-out;\n  }\n  \n  .details-header {\n    margin-bottom: 30px;\n  }\n  \n  .back-link-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    color: #6B7280;\n  }\n  .back-link-button img {\n    width: 24px;\n  }\n  \n  .profile-header {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 40px;\n    background-color: #fff;\n    padding: 24px;\n    border-radius: 12px;\n  }\n  \n  .profile-avatar {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 2px solid #f3f4f6;\n  }\n  \n  .profile-info h1 {\n    font-size: 28px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n  }\n  \n  .profile-actions {\n    margin-left: auto;\n    display: flex;\n    gap: 12px;\n  }\n  \n  .action-btn-secondary, .action-btn-danger {\n    border: 1px solid;\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  .action-btn-secondary {\n    border-color: #d1d5db;\n    background-color: #fff;\n    color: #374151;\n  }\n  .action-btn-secondary:hover {\n    background-color: #f9fafb;\n  }\n  .action-btn-danger {\n    border-color: #ef4444;\n    background-color: #ef4444;\n    color: #fff;\n  }\n  .action-btn-danger:hover {\n    background-color: #dc2626;\n  }\n  \n  \n  .details-content {\n    background-color: #fff;\n    padding: 24px;\n    border-radius: 12px;\n  }\n  .details-content h3 {\n    margin-top: 0;\n    font-size: 18px;\n    border-bottom: 1px solid #f3f4f6;\n    padding-bottom: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .info-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n  \n  .info-pair {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n  .info-pair label {\n    font-size: 14px;\n    color: #6B7280;\n  }\n  .info-pair span {\n    font-size: 16px;\n    color: #1F2937;\n    font-weight: 500;\n    word-break: break-word;\n  }\n  .info-pair.full-width {\n    grid-column: 1 / -1;\n  }\n  \n  /* Status Badges - reuse from previous CSS */\n  .status-badge { padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 500; }\n  .status-active { background-color: #DEF7EC; color: #046C4E; }\n  .status-inactive { background-color: #FEE2E2; color: #991B1B; }\n  \n  @media (max-width: 768px) {\n    .profile-header { flex-direction: column; align-items: flex-start; }\n    .profile-actions { margin-left: 0; width: 100%; justify-content: flex-start; }\n    .info-grid { grid-template-columns: 1fr; }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
